export enum Specialization {
  GeneralPractitioner = 'GeneralPractitioner',
  Dermatologist = 'Dermatologist',
  Cardiologist = 'Cardiologist',
  Pediatrician = 'Pediatrician',
  Orthopedic = 'Orthopedic',
  Dentist = 'Dentist',
  Gynecologist = 'Gynecologist',
  Psychiatrist = 'Psychiatrist',
  Neurologist = 'Neurologist',
  Other = 'Other',
}
